import { Search } from 'lucide-react';
import { useId, type ComponentPropsWithRef } from 'react';
import styles from './SearchBox.module.css';

export type SearchBoxProps = Omit<ComponentPropsWithRef<'input'>, 'type' | 'name'> & {
  label: string;
  onSearch: (text: string) => void;
  shortcut?: string | undefined;
  submitLabel?: string | undefined;
  type?: 'search' | 'tel';
};

const FIELD_NAME = 'search';

export const SearchBox = ({
  label,
  onSearch,
  shortcut,
  submitLabel,
  id,
  type = 'search',
  ...rest
}: SearchBoxProps) => {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <form
      role="search"
      className={styles['box']}
      onSubmit={(event) => {
        event.preventDefault();
        const text = new FormData(event.currentTarget).get(FIELD_NAME);
        onSearch(typeof text === 'string' ? text : '');
      }}
    >
      <label htmlFor={inputId} className="visually-hidden">
        {label}
      </label>
      <Search size={16} aria-hidden="true" className={styles['icon']} />
      <input
        id={inputId}
        name={FIELD_NAME}
        type={type}
        className={styles['input']}
        autoComplete="off"
        {...rest}
      />
      {shortcut === undefined ? null : (
        <kbd className={styles['shortcut']} aria-hidden="true">
          {shortcut}
        </kbd>
      )}
      {submitLabel === undefined ? null : (
        <button type="submit" className={styles['submit']} aria-label={submitLabel} title={submitLabel}>
          <Search size={16} aria-hidden="true" />
        </button>
      )}
    </form>
  );
};
